export const PROJECT_NAME = "NUVELOR";

export const PRIMARY_SITE_URL =
  import.meta.env.VITE_PRIMARY_SITE_URL || "https://nuvelor.gg";
export const SECONDARY_SITE_URL =
  import.meta.env.VITE_SECONDARY_SITE_URL || "https://nuvelor.world";
export const PUBLIC_APP_URL =
  import.meta.env.VITE_PUBLIC_APP_URL || "https://app.nuvelor.gg";
export const PUBLIC_MARKET_URL =
  import.meta.env.VITE_PUBLIC_MARKET_URL || "https://market.nuvelor.gg/";
export const PUBLIC_MARKET_HOST = new URL(PUBLIC_MARKET_URL).hostname;

export function isCanonicalMarketHost(hostname) {
  return String(hostname || "").trim().toLowerCase() === PUBLIC_MARKET_HOST;
}

export function isStandaloneMarketEntry(locationLike, documentElement) {
  const entry = String(documentElement?.dataset?.nuvelorEntry || "").trim().toLowerCase();
  return entry === "market" || isCanonicalMarketHost(locationLike?.hostname);
}

export function resolvePublicApiOrigin(
  locationLike,
  documentElement = typeof document !== "undefined" ? document.documentElement : null
) {
  if (isStandaloneMarketEntry(locationLike, documentElement)) {
    return String(locationLike?.origin || PUBLIC_MARKET_URL).replace(/\/+$/, "");
  }
  return PUBLIC_APP_URL.replace(/\/+$/, "");
}

export const TELEGRAM_CHANNEL_USERNAME = "Nuvelor";
export const TELEGRAM_CHAT_USERNAME = "Nuvelor_Chat";
export const TELEGRAM_BOT_USERNAME = "NuvelorBot";

export const TELEGRAM_CHANNEL_URL = `https://t.me/${TELEGRAM_CHANNEL_USERNAME}`;
export const TELEGRAM_CHAT_URL = `https://t.me/${TELEGRAM_CHAT_USERNAME}`;
export const TELEGRAM_BOT_URL = `https://t.me/${TELEGRAM_BOT_USERNAME}`;

export const X_URL = "https://x.com/nuvelor";
export const INSTAGRAM_URL = "https://instagram.com/nuvelor";

export const REFERRAL_COOKIE_NAME = "nuvelor_ref";
export const REFERRAL_SET_AT_STORAGE_KEY = "nuvelor_ref_set_at";
export const CONNECT_COOKIE_NAME = "nuvelor_connect";
export const CONNECT_CLOUD_KEY = "nuvelor_connect";
export const DEBUG_ENABLED_STORAGE_KEY = "nuvelor_debug_enabled";
export const DEBUG_STORAGE_KEY = "nuvelor_debug_storage";
export const DEBUG_COOKIE_KEY = "nuvelor_debug_cookie";

export const ROOT_COOKIE_DOMAIN = ".nuvelor.gg";
export const ICON_URL = `${PRIMARY_SITE_URL}/icon.png`;

export function referralLandingUrl(code) {
  if (!code) return "";
  return `${PRIMARY_SITE_URL}/r/${encodeURIComponent(code)}`;
}

export function telegramBotReferralUrl(code) {
  if (!code) return TELEGRAM_BOT_URL;
  return `${TELEGRAM_BOT_URL}?startapp=ref_${encodeURIComponent(code)}`;
}
